<template>
  <div>
    <iframe
      v-if="hosting=='youtube'"
      :width="propWidth"
      :height="propHeight"
      :src="`https://www.youtube.com/embed/${code}`"
      title=""
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>

  </div>
</template>
<script>
export default {
  name: "AppVideoEmbed",
  props: {
    code: {
      type: String,
      default: "",
    },
    propWidth: {
      type: String,
      default: "100%",
    },
    propHeight: {
      type: String,
      default: "100%",
    },
    hosting: {
      type: String,
      default: "youtube",
    },
  },
};
</script>
